import { memo } from 'react';
import { SliderMatch } from './SliderMatch';
import { ContentSection } from './content';
import { TournamentRanking } from '../ranking';

export function TournamentOverview(props: any) {
    return (
        <>
            <SliderMatch {...props} />
            <TournamentRanking {...props} />
            <ContentSection {...props} />
        </>
    );
}

export default memo(TournamentOverview);
